import { Box } from "@mui/joy";
import IconButtonCTA from "components/common/IconButtonCTA";
import ActionTooltip from "components/common/ActionTooltip";
import DarkTypography from "components/common/DarkTypography";
import { SOpenProfile } from "styles/StyledMUI";

export function purchaseProductAriaLabel(label: string, qualification?: string): string {
  const q = qualification?.trim();
  return q
    ? `Acheter ou attribuer un produit pour ${label} (${q})`
    : `Acheter ou attribuer un produit pour ${label}`;
}

type ExcursionCounterClientNameProps = {
  label: string;
  qualification?: string;
  onOpenCustomerOverview?: () => void;
};

export default function ExcursionCounterClientName({
  label,
  qualification,
  onOpenCustomerOverview,
}: ExcursionCounterClientNameProps) {
  const q = qualification?.trim();

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 0.5,
        columnGap: 0.75,
        minWidth: 0,
      }}
    >
      {typeof onOpenCustomerOverview === "function" ? (
        <Box sx={{ flexShrink: 0, display: "inline-flex", alignItems: "center" }}>
          <ActionTooltip title="Fiche client">
            <IconButtonCTA
              size="sm"
              variant="plain"
              aria-label="Fiche client"
              ctaVariant="accent"
              onClick={(e) => {
                e.stopPropagation();
                onOpenCustomerOverview();
              }}
              sx={{ "--IconButton-size": "22px" }}
            >
              <SOpenProfile sx={{ fontSize: "0.92rem" }} />
            </IconButtonCTA>
          </ActionTooltip>
        </Box>
      ) : null}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "baseline",
          gap: 0.5,
          columnGap: 0.75,
          minWidth: 0,
        }}
      >
        <DarkTypography level="body-sm" colorVariant="primary" sx={{ fontWeight: 600 }}>
          {label}
        </DarkTypography>
        {q ? (
          <DarkTypography level="body-xs" colorVariant="muted" component="span">
            · {q}
          </DarkTypography>
        ) : null}
      </Box>
    </Box>
  );
}
